import { toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-c2758f2c"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "is-flex is-flex-direction-column gap-4"
}
const _hoisted_2 = { class: "" }
const _hoisted_3 = { class: "title is-5 mb-2 is-flex is-align-items-center gap-2" }
const _hoisted_4 = { class: "has-text-grey-dark" }
const _hoisted_5 = { class: "is-flex gap-1" }
const _hoisted_6 = {
  key: 0,
  class: "tag"
}
const _hoisted_7 = {
  key: 1,
  class: "tag"
}
const _hoisted_8 = {
  key: 2,
  class: "tag"
}
const _hoisted_9 = { class: "is-flex gap-1" }
const _hoisted_10 = ["href"]
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Open in LINDAS", -1))
const _hoisted_12 = ["href"]
const _hoisted_13 = ["disabled", "href"]
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "View full log", -1))
const _hoisted_15 = {
  key: 1,
  class: "has-background-danger-light"
}
const _hoisted_16 = ["href"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_job_status = _resolveComponent("job-status")!
  const _component_external_term = _resolveComponent("external-term")!
  const _component_o_icon = _resolveComponent("o-icon")!
  const _component_b_message = _resolveComponent("b-message")!
  const _component_markdown_render = _resolveComponent("markdown-render")!
  const _component_o_tooltip = _resolveComponent("o-tooltip")!
  const _component_validation_report_display = _resolveComponent("validation-report-display")!
  const _component_loading_block = _resolveComponent("loading-block")!

  return (_ctx.job)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("header", _hoisted_2, [
          _createElementVNode("h2", _hoisted_3, [
            _createTextVNode(_toDisplayString(_ctx.job.name) + " ", 1),
            _createVNode(_component_job_status, {
              job: _ctx.job,
              "show-label": true
            }, null, 8, ["job"])
          ]),
          _createElementVNode("p", _hoisted_4, " Triggered at " + _toDisplayString(_ctx.createdDate), 1)
        ]),
        _createElementVNode("div", _hoisted_5, [
          (_ctx.job.revision)
            ? (_openBlock(), _createElementBlock("span", _hoisted_6, " Version " + _toDisplayString(_ctx.job.revision), 1))
            : _createCommentVNode("", true),
          (_ctx.job.status)
            ? (_openBlock(), _createElementBlock("span", _hoisted_7, [
                _createVNode(_component_external_term, {
                  resource: _ctx.job.status
                }, null, 8, ["resource"])
              ]))
            : _createCommentVNode("", true),
          (_ctx.job.publishedTo)
            ? (_openBlock(), _createElementBlock("span", _hoisted_8, [
                _createVNode(_component_external_term, {
                  resource: _ctx.job.publishedTo
                }, null, 8, ["resource"])
              ]))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_9, [
          (_ctx.job.query)
            ? (_openBlock(), _createElementBlock("a", {
                key: 0,
                href: _ctx.job.query,
                target: "_blank",
                rel: "noopener",
                class: "button is-small"
              }, [
                _hoisted_11,
                _createVNode(_component_o_icon, { icon: "chevron-right" })
              ], 8, _hoisted_10))
            : _createCommentVNode("", true),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.job.workExamples, (workExample) => {
            return (_openBlock(), _createElementBlock("a", {
              key: workExample.id.value,
              href: workExample.url.value,
              target: "_blank",
              rel: "noopener",
              class: "button is-small"
            }, [
              _createElementVNode("span", null, _toDisplayString(_ctx.workExampleLabel(workExample)), 1),
              _createVNode(_component_o_icon, { icon: "external-link-alt" })
            ], 8, _hoisted_12))
          }), 128))
        ]),
        _createElementVNode("div", null, [
          (_ctx.error.disambiguatingDescription)
            ? (_openBlock(), _createBlock(_component_b_message, {
                key: 0,
                type: "is-danger",
                class: "mb-2"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.error.disambiguatingDescription), 1)
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.job.comments, (comment) => {
            return (_openBlock(), _createBlock(_component_b_message, {
              key: comment,
              type: "is-warning",
              class: "mb-2"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_markdown_render, { source: comment }, null, 8, ["source"])
              ]),
              _: 2
            }, 1024))
          }), 128)),
          _createVNode(_component_o_tooltip, {
            label: "Only accessible for technical users",
            position: "right"
          }, {
            default: _withCtx(() => [
              _createElementVNode("a", {
                disabled: !_ctx.link,
                href: _ctx.link,
                target: "_blank",
                rel: "noopener noreferer",
                class: "button is-small mb-1"
              }, [
                _createVNode(_component_o_icon, { icon: "book" }),
                _hoisted_14
              ], 8, _hoisted_13)
            ]),
            _: 1
          }),
          (_ctx.error.description)
            ? (_openBlock(), _createElementBlock("pre", _hoisted_15, "        " + _toDisplayString(_ctx.error.description) + "\n      ", 1))
            : _createCommentVNode("", true),
          (_ctx.error.validationReport)
            ? (_openBlock(), _createBlock(_component_b_message, {
                key: 2,
                type: "is-danger"
              }, {
                header: _withCtx(() => [
                  _createElementVNode("p", null, [
                    _createTextVNode(" Validation error "),
                    (_ctx.error.url)
                      ? (_openBlock(), _createElementBlock("a", {
                          key: 0,
                          href: _ctx.error.url.value,
                          target: "_blank"
                        }, [
                          _createTextVNode(" Open in SHACL UI "),
                          _createVNode(_component_o_icon, { icon: "external-link-alt" })
                        ], 8, _hoisted_16))
                      : _createCommentVNode("", true)
                  ])
                ]),
                default: _withCtx(() => [
                  _createVNode(_component_validation_report_display, {
                    report: _ctx.error.validationReport
                  }, null, 8, ["report"])
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ])
      ]))
    : (_openBlock(), _createBlock(_component_loading_block, { key: 1 }))
}